<template>
    <div class="table-tr" v-if="patient.patient || patient.invitation">
        <div class="table-td cell-length">
            <a :href="patientURL" @click="showPatient">
                <UserAvatar :user-info="patient" />
                <div class="patient-info">
                    <span v-if="patient.initials !== ''" class="user-name">
                        <strong>{{ patient.fullname }}</strong>
                        <template v-if="patient.age">{{ patient.age }}</template>
                    </span>
                    <span class="patient-mail">{{ patient.email }}</span>
                    <span v-if="patient.phone" class="patient-phone">{{ patient.phone }}</span>
                </div>
            </a>
        </div>

        <div class="table-td cell-state">
            <div v-html="patientStatus"></div>
        </div>

        <div v-if="isDeTherapy" class="table-td cell-state">
            <div v-html="patientPrescription"></div>
        </div>

        <div v-if="isDeTherapy" class="table-td cell-state">
            <div v-html="patientPrescriptionEndDate"></div>
        </div>

        <div class="table-td cell-invite">
            <div>
                <strong v-if="patient.patient">{{ patient.patient.id }}</strong>
                <strong v-else>-</strong>
                /
                <strong v-if="patient.user_id">{{ patient.user_id }}</strong>
                <strong v-else>-</strong>
            </div>
        </div>

        <div class="table-td cell-therapist">
            <UserAvatar :user-info="patient.patient ? patient.patient.doctor : patient.invitation.doctor" size="xs" />

            <span>{{ doctorFullname }}</span>
        </div>

        <div class="table-td cell-therapist">
            <UserAvatar v-if="patient.patient && patient.patient.coach" :user-info="patient.patient.coach" size="xs" />

            <span v-if="patient.patient && patient.patient.coach">{{ patient.patient.coach.fullname }}</span>
        </div>

        <div class="table-td cell-institution">
            <span v-if="institutionName">
                <figure v-if="institutionAvatar" v-html="institutionAvatar"></figure>

                <span>{{ institutionName }}</span>
            </span>
        </div>

        <div class="table-td cell-link">
            <DropdownControl>
                <li v-if="patient.patient && !patient.patient.has_active_subscription && user.country === 'DE'">
                    <a data-dismiss="modal" data-target="#modal-freemium-extension" data-toggle="modal" href="#" @click="openModal">
                        <span>{{ __('Extend the patient') }}</span>
                    </a>
                </li>

                <li v-if="patient.patient && patient.patient.coach">
                    <a :data-coach-id="patient.patient.coach.id" :data-patient-id="patient.patient.id" :data-patient-name="patient.fullname" data-dismiss="modal" data-target="#modal-move-patient" data-toggle="modal" href="#">
                        <span>{{ __('Move the patient') }}</span>
                    </a>
                </li>

                <li>
                    <a class="text-red" data-dismiss="modal" data-target="#modal-anonymize" data-toggle="modal" href="#" @click="openModal">
                        <span>{{ __('Anonymise the patient') }}</span>
                    </a>
                </li>
            </DropdownControl>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        patient: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            selectedUser: {
                type: this.patient.patient ? "user" : "pending",
                id: this.patient.patient ? this.patient.user_id : this.patient.pending_patient_id,
                patient_id: this.patient.patient ? this.patient.patient.id : null,
                fullname: this.patient.fullname,
                subscription_active_to: this.patient.patient ? this.patient.patient.subscription_active_to : null
            },
        }
    },
    watch: {
        patient() {
            this.selectedUser = {
                type: this.patient.patient ? "user" : "pending",
                id: this.patient.patient ? this.patient.user_id : this.patient.pending_patient_id,
                patient_id: this.patient.patient ? this.patient.patient.id : null,
                fullname: this.patient.fullname,
                subscription_active_to: this.patient.patient ? this.patient.patient.subscription_active_to : null
            }
        }
    },
    mounted() {
        Vuemit.listen('Extend-freemium--update-subscription-end-date', this.setSubscriptionToDate)
    },
    computed: {
        patientStatus() {
            if (this.patient.patient) {
                if (!this.patient.patient.active) {
                    return `<strong class='status-inactive'>` + lang.get('Inactive') + `</strong>`
                }

                if (this.patient.patient.has_frozen_account) {
                    return `<strong class='status-frozen'>` + lang.get('Suspended') + `</strong>`
                }

                if (this.patient.patient.onboard) {
                    if (this.patient.patient.coach) {
                        return `<strong class='status-connected'>` + lang.get('Connected') + `</strong>`
                    } else {
                        return `<strong class='status-inapp'>In-app</strong>`
                    }
                } else {
                    return `<strong class='status-onboarding'>Onboarding</strong>`
                }
            } else {
                return `<strong class='status-onboarding'>Onboarding</strong>`
            }
        },
        doctorFullname() {
            if (this.patient.patient) {
                return this.patient.patient.doctor.fullname
            } else {
                return this.patient.invitation.doctor.fullname
            }
        },
        institutionAvatar() {
            if (this.patient.patient && this.patient.patient.institution && this.patient.patient.institution.icon) {
                return `<img src="${this.patient.patient.institution.icon}" alt="Avatar" />`
            } else if (this.patient.invitation && this.patient.invitation.institution) {
                return `<img src="${this.patient.invitation.institution.icon}" alt="Avatar" />`
            }
        },
        institutionName() {
            if (this.patient.patient && this.patient.patient.institution) {
                return this.patient.patient.institution.name
            } else if (this.patient.invitation && this.patient.invitation.institution) {
                return this.patient.invitation.institution.name
            }
        },
        patientURL() {
            if (this.patient.patient) {
                return `/pacient/${this.patient.patient.id}`
            } else {
                return "#"
            }
        },
        patientPrescription() {
            if(this.patient.patient && this.patient.patient.has_active_subscription) {
                return `<strong class='status-connected'>` + lang.get('Active') + ' ('+ this.patient.patient.subscription_cycle_number +  `.)</strong>`
            }

            if(this.patient.patient && this.patient.patient.has_freemium) {
                if(this.patient.patient.phase === 'intensive') {
                    return `<strong class='status-frozen'>Freemium</strong>`
                } else {
                    return `<strong class='status-frozen'>`+ lang.get('Transitional period') +`</strong>`
                }
            }
        },
        patientPrescriptionEndDate() {
            if(this.patient.patient && this.patient.patient.subscription_active_to) {
                let prescriptionDate = moment(this.selectedUser.subscription_active_to).diff(moment().subtract(1, 'days'), 'days')

                if(prescriptionDate === 0) {
                    return `<strong class='status-frozen'>`+ lang.get('Today') +`</strong>`
                } else if(prescriptionDate === 1) {
                    return `<strong class='status-frozen'>`+ lang.get('Tomorrow') +`</strong>`
                } else if(prescriptionDate < 16) {
                    return `<strong class='status-onboarding'>`+ lang.choice('{1} :days d|[2,*] :days d', prescriptionDate, {'days': prescriptionDate}) +`</strong>`
                } else {
                    return `<strong class='status-connected'>`+ lang.choice('{1} :days d|[2,*] :days d', prescriptionDate, {'days': prescriptionDate}) +`</strong>`
                }
            }
        },
        isDeTherapy() {
            if (this.user.country === 'DE') {
                return true
            }

            return false
        }
    },
    methods: {
        openModal() {
            this.$emit('select', this.selectedUser)
        },
        showPatient() {
            Vuemit.fire('Search--patient-showed')
        },
        setSubscriptionToDate(data) {
            if(data.id === this.selectedUser.id) {
                this.selectedUser.subscription_active_to = data.date
            }
        }
    }
}
</script>
